const languageMixin = {
	data() {
		return {
			language: window.currentLanguage,
			translations: window.translations,
			isSuperUser: window.isSuperUser
		}
	},
	methods: {

		_addKeyForTranslation (key, defaultValue) {
			if (!this.isSuperUser) {
				return;
			} else {
				let data = {
					key: key
				}
				data[`value_${this.language}`] = defaultValue;
				axios({
					method: 'POST',
					url: `/api/v1/contentsjs`,
					headers: {
					  'X-CSRFToken': window.csrfToken
					},
					data: data
				  }).then((response) => {
					
				  }).catch((error) => {
					  // handle error
				  })
			}
		},
		t (key, defaultValue) {
			if (this.translations.hasOwnProperty(key)) {
				if (this.translations[key]) {
					return this.translations[key]
				} else {
					return defaultValue;
				}
			} else {
				this._addKeyForTranslation(key, defaultValue);
				return defaultValue;
			}
		}
	}
}
